import React, { FC, useCallback } from 'react';
import cx from 'classnames';
import { formatNumber } from 'core/functions/formatNumber';
import styles from './CellDefault.module.scss';

type CellDefaultProps = {
	text: string | number;
	parentClassName: string;
	boldDefaultOrg?: boolean;
};

const getDisplayText = (text: string | number): string => {
	if (typeof text === 'number' && Number.isFinite(text)) {
		return formatNumber(text);
	}

	return String(text);
};

const CellDefault: FC<CellDefaultProps> = ({ text, parentClassName, boldDefaultOrg }: CellDefaultProps) => {
	const displayText = getDisplayText(text);

	const Content = useCallback(() => {
		if (boldDefaultOrg) {
			const [defaultOrg, ...orgs] = displayText.split(', ');
			return (
				<span>
					<b>{defaultOrg}</b>
					{orgs.length ? ', ' : ''} {orgs.join(', ')}
				</span>
			);
		}

		return <span>{displayText}</span>;
	}, [displayText, boldDefaultOrg]);

	return (
		<div className={cx(styles.main, styles[parentClassName])} title={displayText}>
			<Content />
		</div>
	);
};

export default CellDefault;
